import { IconProps } from 'types';

const ReminderIcon = ({ title = 'Reminder', className }: IconProps) => (
    <svg className={className} width="24" height="24" viewBox="0 -960 960 960" fill="none">
        <title>{title}</title>
        <path d="M600-80v-80h160v-400H200v160h-80v-320q0-33 23.5-56.5T200-800h40v-80h80v80h320v-80h80v80h40q33 0 56.5 23.5T840-720v560q0 33-23.5 56.5T760-80H600ZM320 0l-56-56 103-104H40v-80h327L264-344l56-56 200 200L320 0ZM200-640h560v-80H200v80Zm0 0v-80 80Z" fill="currentColor" />
    </svg>
);

export default ReminderIcon;
